import { useFieldArray, useFormContext } from "react-hook-form";
import { InformationCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import AddMoreMagnetButton from "components/atoms/buttons/AddMoreMagnetButton";
import TextAreaWithLabel from "components/molecules/forms/TextAreaWithLabel";
import MagnetBenefitCard from "components/organisms/cards/MagnetBenfitCard";
import ListAnimator from "components/atoms/ListAnimator";

function MagnetDetailsForm() {
  const {
    register,
    formState: { errors },
    watch,
    control,
    getValues,
    setValue,
  } = useFormContext<CreateUpdateMagnetFormType>();

  const { fields, append, remove } = useFieldArray({ control, name: "benefits" });

  const handleAddMagnetBenefit = () => {
    append({
      image: "",
      title: "",
      description: "",
      image_hash: null,
    });
  };

  const handeRemoveMagnetBenfit = (idx: number) => {
    remove(idx);
  };

  return (
    <div className="mx-auto">
      <div className=" flex flex-col">
        <p className="px-auto flex font-satoshi text-xs font-semibold text-white">
          <InformationCircleIcon className="mr-2 h-6 w-6" />
          The below details can be edited at any time.
        </p>
        <div className=" mt-5 flex flex-row items-start gap-5">
          <div className="w-1/3">
            <TextAreaWithLabel
              label="Magnetized Because"
              id="magnetized_because"
              rows={5}
              placeHolder="Tell your consumers why this Magnet matters."
              register={register}
              defaultValue=""
              errorMessage={errors.magnetized_because?.message}
            />
          </div>
        </div>
      </div>
      <div className=" mt-10 space-y-4">
        {/* Not Required in updated figma design */}
        <h6 className="flex gap-x-1 font-sora text-sm font-medium text-white">
          <span>Magnet Benefits</span>
          {fields.length < 6 && (
            <button type="button" onClick={handleAddMagnetBenefit}>
              <PlusCircleIcon className="w-5 text-accent" />
            </button>
          )}
        </h6>
      </div>
      <div className="my-5 grid min-w-full grid-cols-1 gap-x-4 gap-y-7 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4">
        <ListAnimator>
          {fields.map((field, idx: number) => (
            <div key={`magnetBenfit${field.id}`} className="">
              <MagnetBenefitCard
                handleRemoveBenefit={handeRemoveMagnetBenfit}
                // @ts-ignore
                existingMagnetImage={getValues(`benefits.${idx}.image_url`)}
                watch={watch}
                register={register}
                errors={errors}
                idx={idx}
                setValue={setValue}
              />
            </div>
          ))}
        </ListAnimator>
        {fields.length < 6 && fields.length !== 3 && (
          <AddMoreMagnetButton
            text="Add Magnet Benefit"
            onclick={handleAddMagnetBenefit}
            additionalClasses="min-h-[100px]"
          />
        )}
      </div>
    </div>
  );
}
export default MagnetDetailsForm;
